export default {
  APP_NAME: '审批管理平台',

  APPROVAL_AUTHORITY: {
    0: '无审批权限',
    1: '有内部审批权限',
    2: '有外部审批权限'
  },
  APPROVAL_STATUS: {
    0: '未处理',
    1: '通过',
    2: '拒绝',
    3: '已撤回',
    101: '一级审批通过',
    102: '二级审批通过',
    103: '三级审批通过',
    201: '一级拒绝',
    202: '二级拒绝',
    203: '三级拒绝'
  },
  APPROVAL_MODEL: {
    1: 'OTA单人单节点审批',
    2: '单人二级审批',
    1101: 'PKI一级审批',
    1102: 'PKI二级审批',
    1103: 'PKI三级审批'
  }
}
